<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Category Preview"
      id="admin_delete_category_category_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="category.name"
        :icon="category.icon"
        :img_src="category.thumb_nail"
        :facts="view_header_facts"
        :description="category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Category Concent Form "
      id="admin_delete_category_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="categories_delete_form_ref"
      id="categories_delete_form"
      message="<b>Delete was succesfull</b> <br/> Category has been removed"
      :is_loading="is_loading"
      :seed="{category:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminCategoriesDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      category: Utils.get_default_category(),
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to categories list
      this.$router.push("/admin/categories/list");
    },
    load_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_category(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("category to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.category = res;
            this.get_deps();
          }
          //this.$refs.edit_form_ref.init_editing_form(this.category);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading category details on admin delete category ",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Top Category:",
          val: parseInt(this.category.is_top_category == 1) ? "Yes" : "No",
        },
        { text: "Top Category Level:", val: this.category.top_category_level },
      ];
      return facts;
    },
  },
  mounted() {
    var category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Delete Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/categories/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/categories/view/" + category_id,
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/categories/view/" + category_id + "/delete",
        },
      ],
      navbar_cols: 3,
    });
    this.load_category();
  },
};
</script>